// extracted by mini-css-extract-plugin
export var indicator = "Indicator-module--indicator--6484e";
export var inline = "Indicator-module--inline--d33d7";
export var rotation = "Indicator-module--rotation--05553";